/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExpectationMetadata } from "./QuoteTestExpectationMetadata";
import {
  QuoteTestExpectationMetadataFromJSON,
  QuoteTestExpectationMetadataFromJSONTyped,
  QuoteTestExpectationMetadataToJSON,
  QuoteTestExpectationMetadataToJSONTyped,
} from "./QuoteTestExpectationMetadata";
import type { QuoteTestExpectationType } from "./QuoteTestExpectationType";
import {
  QuoteTestExpectationTypeFromJSON,
  QuoteTestExpectationTypeFromJSONTyped,
  QuoteTestExpectationTypeToJSON,
  QuoteTestExpectationTypeToJSONTyped,
} from "./QuoteTestExpectationType";

/**
 *
 * @export
 * @interface QuoteTestExecutionExpectationDto
 */
export interface QuoteTestExecutionExpectationDto {
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExecutionExpectationDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectationDto
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExpectationType}
   * @memberof QuoteTestExecutionExpectationDto
   */
  type?: QuoteTestExpectationType;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectationDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectationDto
   */
  metadata?: string;
  /**
   *
   * @type {QuoteTestExpectationMetadata}
   * @memberof QuoteTestExecutionExpectationDto
   */
  parsedMetadata: QuoteTestExpectationMetadata;
}

/**
 * Check if a given object implements the QuoteTestExecutionExpectationDto interface.
 */
export function instanceOfQuoteTestExecutionExpectationDto(
  value: object,
): value is QuoteTestExecutionExpectationDto {
  if (!("parsedMetadata" in value) || value["parsedMetadata"] === undefined)
    return false;
  return true;
}

export function QuoteTestExecutionExpectationDtoFromJSON(
  json: any,
): QuoteTestExecutionExpectationDto {
  return QuoteTestExecutionExpectationDtoFromJSONTyped(json, false);
}

export function QuoteTestExecutionExpectationDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionExpectationDto {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExpectationTypeFromJSON(json["type"]),
    description: json["description"] == null ? undefined : json["description"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parsedMetadata: QuoteTestExpectationMetadataFromJSON(
      json["parsedMetadata"],
    ),
  };
}

export function QuoteTestExecutionExpectationDtoToJSON(
  json: any,
): QuoteTestExecutionExpectationDto {
  return QuoteTestExecutionExpectationDtoToJSONTyped(json, false);
}

export function QuoteTestExecutionExpectationDtoToJSONTyped(
  value?: QuoteTestExecutionExpectationDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    type: QuoteTestExpectationTypeToJSON(value["type"]),
    description: value["description"],
    metadata: value["metadata"],
    parsedMetadata: QuoteTestExpectationMetadataToJSON(value["parsedMetadata"]),
  };
}
